import { Route, Switch } from 'react-router';

import useCurrentPath from 'common/hooks/useCurrentPath';

import { FiltersProvider } from '../hooks/useFilters';
import DetailsPage from './pages/Details';
import ListPage from './pages/List';

const Clients = () => {
  const { path } = useCurrentPath();

  return (
    <Switch>
      <Route exact path={path}>
        <FiltersProvider>
          <ListPage />
        </FiltersProvider>
      </Route>

      <Route component={DetailsPage} path={`${path}/:clientId?`} />
    </Switch>
  );
};

export default Clients;
